// spjs ブリッジ呼び出しが上限時間内に settle しなかったことを表す（#7706）。
// 「ブリッジの無応答」であり、BT off（BluetoothNotOnException）や scan 不成立
// （ScanTimeoutException）とは区別する。UnlockPage の既存分類では UnknownError 画面に
// 落ちる（ネイティブの connect 失敗も unknown 画面のためパリティが取れている）。
export class BridgeCallTimeoutException extends Error {
  readonly label: string
  readonly capMs: number
  constructor(label: string, capMs: number) {
    super(`spjs bridge call did not settle within ${capMs}ms: ${label}`)
    this.name = 'BridgeCallTimeoutException'
    this.label = label
    this.capMs = capMs
    // es5 ターゲットで instanceof を機能させる
    Object.setPrototypeOf(this, BridgeCallTimeoutException.prototype)
  }
}
